import { RxCross2 } from "react-icons/rx";
import { Button, Modal, ModalBody } from "reactstrap";
import { useTranslation } from "../../languages";

const AboutUs = ({ modalOpen, setModalOpen }) => {
  const { t } = useTranslation();
  return (
    <Modal isOpen={modalOpen} size={"lg"} fade={false} centered>
      <ModalBody className="bg-white p-4" style={{ borderRadius: "28.24px" }}>
        <div className="d-flex align-items-center mb-4 justify-content-between">
          <Button
            onClick={() => setModalOpen(false)}
            className="p-0 bg-primary-blue full-rounded border-none"
            style={{ height: 44, width: 44, aspectRatio: 1 }}
          >
            <RxCross2 strokeWidth={`1px`} size={20} />
          </Button>
          <h3 className="f-6  figma-shadowed-black-text m-0 ">
            {t("aboutUs")}
          </h3>
          <div style={{ height: 44, width: 44 }}></div>
        </div>
        <div>
          <p className="f-5" style={{ color: "rgba(0, 0, 0, 0.6)" }}>
            {t("aboutUsParagraph1")}
          </p>
          <p className="f-5" style={{ color: "rgba(0, 0, 0, 0.6)" }}>
            {t("aboutUsParagraph2")}
          </p>
          <p className="f-5" style={{ color: "rgba(0, 0, 0, 0.6)" }}>
            {t("aboutUsParagraph3")}
          </p>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default AboutUs;
